import { default as calculationDmsK6mjQtMMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detail0Cka4IXaI1Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquirygWWOOft6dNMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_930m6ouEqP2EMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listqoH6ejLjZMMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testing9WS6Qm7rPtMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyouTA4bqSEIgrMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellpcQtAqux9ZMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostm6JsRRTvIpMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankyDewUDngC1Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniI8aPo0CWWMMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageM7rlthEiP9Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45test83FZtWyXq4Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepageLTSBxjvtDkMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as article0eo5xqxV9BMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsdTZoz3Kkk1Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagNFhvzmlxUPMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autor8XPnrlAC6HMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as category4ufFgcKZynMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionW3S2oMLJkkMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articles8mspERorInMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryCkNrOFyelIMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleJXLtbr4AfHMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionPKgVPrFDOOMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contact919ZizhCDYMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationFh0D9aG27PMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationR8QUo0HKCYMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youuM9HApKksbMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailzfrAURmLFRMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiry2G2aGwZxllMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listZVjCkkdFjIMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationQ4AChNXcuWMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youxs4timMXFMMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiry9tQOXQy84LMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listNSCtN9XiSAMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailLwsaXnRcAjMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerAmGMvScI60Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryu8qAKY15FnMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youCfP0pPKlD7Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationCPSW8uPxEYMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listQw37qtjuvUMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youa1l0PIEXMcMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlines5MSvKLiT6Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailHm5AyRpkT0Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneez0mgBBW13Meta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offersOKmUgdxENMeta } from "/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostm6JsRRTvIpMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankyDewUDngC1Meta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniI8aPo0CWWMMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageM7rlthEiP9Meta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45test83FZtWyXq4Meta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepageLTSBxjvtDkMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: article0eo5xqxV9BMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsdTZoz3Kkk1Meta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagNFhvzmlxUPMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autor8XPnrlAC6HMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: category4ufFgcKZynMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionW3S2oMLJkkMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articles8mspERorInMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageM7rlthEiP9Meta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryCkNrOFyelIMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleJXLtbr4AfHMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionPKgVPrFDOOMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionPKgVPrFDOOMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contact919ZizhCDYMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationFh0D9aG27PMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationR8QUo0HKCYMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youuM9HApKksbMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailzfrAURmLFRMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiry2G2aGwZxllMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listZVjCkkdFjIMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationQ4AChNXcuWMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youxs4timMXFMMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiry9tQOXQy84LMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listNSCtN9XiSAMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailLwsaXnRcAjMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerAmGMvScI60Meta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryu8qAKY15FnMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youCfP0pPKlD7Meta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationCPSW8uPxEYMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listQw37qtjuvUMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youa1l0PIEXMcMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlines5MSvKLiT6Meta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailHm5AyRpkT0Meta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneez0mgBBW13Meta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offersOKmUgdxENMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src2763657869/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]